import { z } from 'zod';
import { WorkbenchRecordTarget } from './workbench-record.js';
/** A full-text, explicitly paged read. Existing compact assistant reads retain
 * their old semantics; a small first page here never means a complete history. */
export const WorkbenchActivityRequest = WorkbenchRecordTarget.safeExtend({
    limit: z.coerce.number().int().min(1).max(50).default(25),
    cursor: z.string().min(1).max(1024).optional().describe('Use the exact next_cursor from the previous activity page. Restart without it after a source change.'),
});
const hash = z.string().regex(/^[a-f0-9]{64}$/);
export const WorkbenchActivityItem = z.object({
    key: z.string().min(1),
    source: z.enum(['crm.touch', 'public.activity_log']),
    source_id: z.string().min(1), source_revision: hash,
    recorded_at: z.iso.datetime({ offset: true }),
    /** Source fields, with the existing canonical activity redaction applied.
     * Never send the raw legacy event payload or superseded/removed note text. */
    data: z.record(z.string(), z.json()),
}).strict();
export const WorkbenchActivityCoverage = z.object({
    source: z.enum(['crm.touch', 'public.activity_log']),
    state: z.enum(['loaded', 'empty', 'not_applicable', 'unavailable']),
    count: z.number().int().nonnegative(),
    reason: z.enum(['record_touches', 'live_job_history', 'opportunity_has_no_job_history', 'legacy_history_has_no_test_shadow']),
}).strict();
export const WorkbenchActivityPage = z.object({
    contract: z.literal('aiw.workbench.activity/1'),
    actor_id: z.uuid(), test_set_id: z.uuid().nullable(),
    target: WorkbenchRecordTarget, record_key: z.string().min(1),
    snapshot_revision: hash, observed_at: z.iso.datetime({ offset: true }),
    coverage: z.array(WorkbenchActivityCoverage).length(2),
    page: z.object({ offset: z.number().int().nonnegative(), limit: z.number().int().min(1).max(50),
        total: z.number().int().nonnegative(), has_more: z.boolean(), next_cursor: z.string().nullable() }).strict(),
    items: z.array(WorkbenchActivityItem).max(50),
}).strict();
//# sourceMappingURL=workbench-activity.js.map